import { IStoreState, ThunkDispatch } from '../../modules';
import { ListItemIcon, ListItemText } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import { Record, SdkAction, SoapExchange, setActiveItem } from '../../modules/tracelog';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import { faCaretLeft, faCaretRight, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import Collapse from '@material-ui/core/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grow from '@material-ui/core/Grow';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { ViewItem } from './viewers/Viewer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { generateAvatar } from '../../helpers/user';
import parser from 'fast-xml-parser';

const styles = (theme: Theme) => createStyles({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  exchangePaper: {
    marginBottom: theme.spacing(1),
  },
  inline: {
    display: 'inline',
  },
  new: {
    fontWeight: 'bold',
    backgroundColor: 'rgba(255,249,196 ,1)'
  },
  mobileSdkIcon: {
  }
});

type State = {
  open: boolean
  visible: boolean
}

class ExchangesListItem extends Component<Props, State> {
  state = {
    open: false,
    visible: false,
  }

  handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const { tracelog, setActiveItem } = this.props

    if (this.state.open && tracelog.activeItem && tracelog.activeItem === this.props.record)
      setActiveItem()
    this.setState({ open: !this.state.open })
    e.preventDefault()
  }

  extractXMLValue = (obj: any, name: string) => {
    let result: string[] = []
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if ("object" === typeof obj[key]) {
          result = result.concat(this.extractXMLValue(obj[key], name));
        } else if (key === name) {
          result.push(obj[key]);
        }
      }
    }
    return result;
  }

  handleSelectTrace = (record: Record, viewItem: ViewItem) => () => {
    this.props.setActiveItem(record, viewItem)
  }

  componentDidMount = () => {
    this.setState({
      visible: true,
    });
  }

  renderSdkAction(sdkAction: SdkAction) {
    const { classes, tracelog } = this.props

    let primaryText = sdkAction.method + "(" + (sdkAction.arguments.length > 0 ? " ... " : "") + ")"
    let secondaryText = sdkAction.platform + " " + sdkAction.module + " module"

    return <ListItem button onClick={this.handleSelectTrace(sdkAction, sdkAction)} alignItems="center" selected={tracelog.activeItem === sdkAction} className={sdkAction.new ? classes.new : undefined }>
      <ListItemIcon className={classes.mobileSdkIcon}>
        <FontAwesomeIcon icon={sdkAction.platform === 'Android' ? faAndroid : faApple} size="3x" />
      </ListItemIcon>
      <ListItemText primary={primaryText} secondary={secondaryText} />
    </ListItem>
  }

  renderSoapExchange(soapExchange: SoapExchange) {
    const { classes, tracelog } = this.props

    let action = "[Unknown]"
    let eventType = ""
    let loginName = ""

    let { request, response } = soapExchange

    if (request != null) {
      let rx = /(?:\w+:)+(\w+)/g
      let arr = rx.exec(request.soapaction || "")
      if (arr !== null && arr.length > 1)
        action = arr[1]

      let xml = parser.parse(request.body, { ignoreNameSpace: true })

      eventType = this.extractXMLValue(xml, "eventType").join(',')
      loginName = this.extractXMLValue(xml, "userName").join(',')
    }

    return (
      <Grow in={this.state.visible}>
        <Fragment>
          <ListItem onClick={this.handleClick} alignItems="center" className={soapExchange.new ? classes.new : undefined }>
            <ListItemIcon>
              {generateAvatar(loginName)}
            </ListItemIcon>
            <ListItemText primary={action} secondary={(<Fragment><Typography component="span" className={classes.inline} color="textPrimary">{eventType}</Typography> for {loginName}</Fragment>)}></ListItemText>
            <FontAwesomeIcon icon={this.state.open ? faChevronUp : faChevronDown} />
          </ListItem>
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List disablePadding className={soapExchange.new ? classes.new : undefined }>
              {request &&
                <ListItem button className={classes.nested} onClick={this.handleSelectTrace(soapExchange, request)} selected={tracelog.activeItem === request}>
                  <ListItemIcon><FontAwesomeIcon icon={faCaretRight} /></ListItemIcon>
                  <ListItemText primary={"Request " + (request.masked ? "(masked)" : "")} />
                </ListItem>
              }
              {response &&
                <ListItem button className={classes.nested} onClick={this.handleSelectTrace(soapExchange, response)} selected={tracelog.activeItem === response}>
                  <ListItemIcon><FontAwesomeIcon icon={faCaretLeft} /></ListItemIcon>
                  <ListItemText primary="Response" />
                </ListItem>
              }
            </List>
          </Collapse>
        </Fragment>
      </Grow>
    )
  }

  render() {
    const { record } = this.props

    if (record.class === "soapexchange") {
      return this.renderSoapExchange(record)
    } else if (record.class === "sdkaction") {
      return this.renderSdkAction(record)
    }
  }
}

const mapStateToProps = ({ auth, intl, tracelog }: IStoreState) => ({
  auth,
  intl,
  tracelog
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      setActiveItem
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  record: Record
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ExchangesListItem))